<template>
  <div id="app">
    <label class="fz-14 mb-1 d-block" style="font-weight:600">
      {{ title }}
    </label>
    <ckeditor :editor="editor" v-model="htmlInput" :config="editorConfig"></ckeditor>
  </div>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfig } from '@/helpers/editor';
export default {
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfig,
    };
  },
  computed: {
    htmlInput: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
